/**
 * Return the platform that the app is compiled for
 * @returns desktop or mobile
 */
export const platform = () =>
  import.meta.env.VITE_PLATFORM === 'desktop' ? 'desktop' : 'mobile'
/**
 * Is the app compiled for desktop
 * @returns true if the app is compiled for desktop
 */
export const isDesktop = () => platform() === 'desktop'
/**
 * Is the app compiled for mobile
 * @returns true if the app is compiled for mobile
 */
export const isMobile = () => platform() === 'mobile'
